import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

import type { SidebarLink } from "../LinkItem";
import { AddLinkModalComponent } from "./AddLinkModalComponent";

export interface AddLinkModalProps {
  isEdit?: boolean;
  link?: SidebarLink;
}

const AddLinkModal = ModalManager.create(
  ({ isEdit, link }: AddLinkModalProps) => {
    const modal = useModal();

    return (
      <AddLinkModalComponent
        isEdit={isEdit}
        link={link}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useAddLinkModal = () => useModal(AddLinkModal);
